import { FormControlLabel, Grid, Radio, RadioGroup, Tooltip } from '@mui/material';
import i18next from 'i18next';
import TourIcon from './Icons/svg/truck01.svg';
import TourIconOrange from './Icons/svg/truck01_orange.svg';
import Van from './Icons/svg/van.svg';
import VanOrange from './Icons/svg/van_orange.svg';
import Car from './Icons/svg/car.svg';
import CarOrange from './Icons/svg/car_orange.svg';
import { NotInterested } from '@mui/icons-material';
import React from 'react';

interface VehicleImageRowProps {
  value: string | null;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  style?: React.CSSProperties;
  className?: string;
  classes?: Record<string, string>;
}

export const VehicleImageRow: React.FC<VehicleImageRowProps> = ({ value,
  onChange,
  disabled = false,
  style = {},
  className,
  classes = {},
}) => {
  return (
    <RadioGroup
      name='vehicle_class'
      value={value === null ? 'none' : value}
      //@ts-ignore
      disabled={disabled}
      style={style}
      className={className}
      onChange={onChange}>
      <Grid container alignItems={'flex-end'} justifyContent={'space-between'}>
        <Tooltip title={i18next.t('common:vehicleEditor:lkwInfo')}>
          <FormControlLabel
            value='truck'
            data-cy={'truck'}
            label={''}
            classes={classes}
            disabled={disabled}
            control={<Radio
              icon={<img src={TourIcon} width={'32px'} height={'32px'} />}
              checkedIcon={<img src={TourIconOrange} width={'32px'} height={'32px'} />}
            />}
          />
        </Tooltip>

        <Tooltip title={i18next.t('common:vehicleEditor:vanInfo')}>
          <FormControlLabel
            value='van'
            label={''}
            data-cy={'van'}
            classes={classes}
            disabled={disabled}
            control={<Radio
              icon={<img src={Van} width={'35px'} height={'35px'} />}
              checkedIcon={<img src={VanOrange} width={'35px'} height={'35px'} />}
            />}
          />
        </Tooltip>

        <Tooltip title={i18next.t('common:vehicleEditor:carInfo')}>
          <FormControlLabel
            value='car'
            data-cy={'car'}
            label={''}
            classes={classes}
            disabled={disabled}
            control={<Radio
              icon={<img src={Car} width={'35px'} height={'35px'} />}
              checkedIcon={<img src={CarOrange} width={'35px'} height={'35px'} />}
            />}
          />
        </Tooltip>

        <FormControlLabel
          value={'none'}
          data-cy={'none'}
          label={''}
          classes={classes}
          disabled={disabled}
          control={
            <Radio
              icon={<NotInterested color='disabled' fontSize={'large'} />}
              checkedIcon={<NotInterested color='primary' fontSize={'large'} />} />}
        />
      </Grid>
    </RadioGroup>
  );
};

export default React.memo(VehicleImageRow);
